<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>
      制作习题
      <span>></span>
      大题列表
    </div>
    <div class="student_test">
      <el-card>
        <div class="rule">
          <div class="xiaoqu_1">大题列表</div>
          <div class="xiaoqu_2"></div>
          <el-row :gutter="24">
            <el-col :span="2">
              <el-button type="primary" icon="el-icon-folder-add"
                         @click="newQuestion = true;referOrganzationTypeList()">
                新建大题
              </el-button>
            </el-col>
            <el-col :span="4" :offset="18">
              <el-button-group>
                <el-button type="primary" :span="2" @click="complateAndBack()" round>完成并返回</el-button>
                <el-button type="primary" :span="2" @click="comeBack()" plain round>暂存并返回</el-button>
              </el-button-group>
            </el-col>
          </el-row>
          <el-row>
            <div class="zsbg">
              <el-table :data="form" border>
                <el-table-column prop="title" label="大题名称"/>
                <el-table-column width="200" prop="questionCount" label="小题个数">
                  <template slot-scope="scope">
                    {{ scope.row.questionCount }}小题
                  </template>
                </el-table-column>
                <el-table-column width="200" label="计分单位总数">
                  <template slot-scope="scope">
                    {{ scope.row.scoreNumber }}
                  </template>
                </el-table-column>
                <el-table-column width="200" label="小题总分数">
                  <template slot-scope="scope">
                    {{ scope.row.totalScore }}
                  </template>
                </el-table-column>
                <el-table-column width="360" label="操作">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="8">
                        <el-button size="mini" icon="el-icon-edit" @click="editrule(scope.row)">编辑</el-button>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="danger" icon="el-icon-delete" size="mini"
                                   @click="removeTypeList(scope.row.type)">删除
                        </el-button>
                      </el-col>
                      <el-col :span="8">
                        <el-button size="mini" icon="el-icon-setting" v-if="scope.row.type!==number"
                                   @click="setScore(scope.row)">设置分数
                        </el-button>
<!--                        <span v-if="scope.row.type!==number&&score">{{ scope.row.totalScore }}</span>
                        <span v-else>{{ scope.row.totalScore }}</span>-->
                        <el-input type="text" size="mini" clearable v-show="scope.row.type===number"
                                  v-model="scope.row.totalScore" @blur="conmitscore(scope.row)"/>
                      </el-col>


                    </el-row>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </el-row>
          <el-row>
            <el-pagination class="fenye" background @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </el-row>
        </div>


      </el-card>
      <el-dialog title="新建类型" :visible.sync="newQuestion" width="50%">
        <span style="color:#CCCCCC; display:inlineBlock; marginRight:20px;">大题类型</span>
        <el-select v-model="choosedType" placeholder="请选择" size="medium" @change="onSelectedDrug($event)">
          <el-option v-for="item in questionType" :key="item.id" :label="item.name" :value="item.type">
          </el-option>
        </el-select>
        <div class="annotation">（注：在创建大题前，请您首先选择要创建的习题类型，再对该大题进行创建及编辑）</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="newQuestion = false">取 消</el-button>
          <el-button type="primary" @click="newQuestion = false;thenewtest()">确 定</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>
const axios = require('axios');
export default {
  data() {
    return {
      dialogFormVisible: false,
      newLevel: false,
      props: {
        label: 'name',
      },
      allbigquestionscore: [],
      setscore1: 0,
      setscorebutton: true,
      score: false,
      bookid_1: '',
      dianxuan: '',
      form: [],
      currentPage: 0,
      page: 1,
      pageSize: 5,
      total: 0,
      questionType: [],
      newQuestion: false,
      choosedType: '',
      questionPackId: '',
      typeName: '',
      number: '',
    };
  },
  created() {
    this.questionPackId = Number(this.$route.query.id);
    this.referOrganzationList();
  },
  methods: {
    onSelectedDrug(e) {
      this.typeName = e;
    },
    handleNodeClick(data) {
      console.log(data.name, '看看这是啥');
    },
    //完成并返回
    complateAndBack() {
      console.log(this.allbigquestionscore);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: 'edu/exercise-pack/submit/' + this.questionPackId,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '11111');
        if (res.data.code === 0) {
          this.$router.push('/exerciselibrary');
        } else {
          this.$message.error(res.data.message)
        }
      });
    },
    //查询大题列表
    referOrganzationList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/exercise-pack/questions/group/' + this.questionPackId,
        params: {
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询习题列表');
        if (res.data.code === 0) {
          this.form = res.data.data;
          this.total = res.data.size;
        }
      });
    },
    //查新的习题
    thenewtest() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/exercise-pack/questions/group/' + this.questionPackId + '/' + this.typeName,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询新的习题列表');
        if (res.data.code === 0) {
          this.form = res.data.data;
          this.total = res.data.size;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    setScore(row) {
      console.log(row);
      this.number = row.type;
      console.log(row.number, this.number);
    },
    //设置分数
    conmitscore(row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/exercise-pack/' + this.questionPackId + '/set/score',
        method: 'POST',
        data: {
          questionType: this.number,
          score: row.totalScore,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          console.log(res);
          this.$message.success('设置成功!');
          this.setscorebutton = false;
          this.allbigquestionscore.push({questionType: this.number, score: Number(row.number)});
          this.number = 0;
          this.score = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //查询大题类型列表
    referOrganzationTypeList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      let pro = this.$http({
        url: '/edu/exercise/question/types',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          console.log(res, '查询习题类型列表');
          this.questionType = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    //删除大题
    removeTypeList(type) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      // console.log(this.miniid,"111");
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let pro = this.$http({
            url: '/edu/exercise-pack/reference/' + this.questionPackId + '/' + type + '/un',
            method: 'POST',
            headers: {
              Authorization: 'Bearer ' + token,
            },
          });
          pro.then((res) => {
            console.log(res, '返回内容');
            this.referOrganzationList();
          });
        })
    },
    comeBack() {
      this.$router.push('/exerciselibrary');
    },
    //编辑习题
    editrule(row) {
      console.log(row);
      this.$router.push({
        path: '/smallquestionlist',
        query: {
          type: row.type,
          id: this.questionPackId,
          littleNode: this.$route.query.littleNode,
          bookid: this.$route.query.bookid,
          number: row.number
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      // this.$options.methods.chaxun()
      this.referOrganzationList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.referOrganzationList();
    },
  },
};
</script>
<style lang="less" scoped>
.rule {
  position: relative;
  margin-top: -20px;

  .xiaoqu_1 {
    font-weight: Bold;
  }

  .xiaoqu_2 {
    position: absolute;
    font-weight: 600;
    font-size: 18px;
    top: 3px;
    right: 0;

    .icon_change {
      position: absolute;
      width: 22px;
      height: 22px;
      right: 77px;
      border-radius: 50%;
      padding: 0;
      // background: url('../../../assets/img/home/qiehuan_1.png') #00a6e6 no-repeat center;
      background-size: 0.85vw;
    }
  }
}

// .el-popper[x-placement^=bottom] {
//   margin-top: 30px;
// }

.el-pagination__editor.el-input .el-input__inner {
  width: 25px !important;
}


.annotation {
  margin-right: 1.875rem /* 30/16 */;
  margin-top: 10px;
  color: red;
  font-size: 14px;
}
</style>
